/*
 * Fraunhofer Institute for Computer Graphics Research (IGD)
 * Competence Center for Information Visualization and Visual Analytics
 *
 * Copyright (c) 2018 Fraunhofer IGD. All rights reserved.
 *
 * This source code is property of the Fraunhofer IGD and underlies
 * copyright restrictions. It may only be used with explicit
 * permission from the respective owner.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContentType, } from './ContentType';
import ConnectionError from './ConnectionError';
import { assembleEndpoint, assembleRequestGET, assembleRequestWithBody } from './RestServiceHelpers';
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPromiseGET(endpoint, additionalOptions) {
    const getEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const getRequest = assembleRequestGET(ContentType.Json, additionalOptions);
    return jsonFetch(getEndpoint, getRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPromisePUT(endpoint, bodyContentObj, additionalOptions) {
    const putEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const putRequest = assembleRequestWithBody('PUT', bodyContentObj, ContentType.Json, additionalOptions);
    return jsonFetch(putEndpoint, putRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPromiseDELETE(endpoint, bodyContentObj, additionalOptions) {
    const deleteEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const deleteRequest = assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Json, additionalOptions);
    return jsonFetch(deleteEndpoint, deleteRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPromisePOST(endpoint, bodyContentObj, additionalOptions) {
    const postEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const postRequest = assembleRequestWithBody('POST', bodyContentObj, ContentType.Json, additionalOptions);
    return jsonFetch(postEndpoint, postRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function jsonPromisePATCH(endpoint, bodyContentObj, additionalOptions) {
    const patchEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const patchRequest = assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Json, additionalOptions);
    return jsonFetch(patchEndpoint, patchRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPromiseGET(endpoint, additionalOptions) {
    const getEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const getRequest = assembleRequestGET(ContentType.Text, additionalOptions);
    return textFetch(getEndpoint, getRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPromisePUT(endpoint, bodyContentObj, additionalOptions) {
    const putEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const putRequest = assembleRequestWithBody('PUT', bodyContentObj, ContentType.Text, additionalOptions);
    return textFetch(putEndpoint, putRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPromiseDELETE(endpoint, bodyContentObj, additionalOptions) {
    const deleteEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const deleteRequest = assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Text, additionalOptions);
    return textFetch(deleteEndpoint, deleteRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPromisePOST(endpoint, bodyContentObj, additionalOptions) {
    const postEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const postRequest = assembleRequestWithBody('POST', bodyContentObj, ContentType.Text, additionalOptions);
    return textFetch(postEndpoint, postRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function textPromisePATCH(endpoint, bodyContentObj, additionalOptions) {
    const patchEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const patchRequest = assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Text, additionalOptions);
    return textFetch(patchEndpoint, patchRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPromiseGET(endpoint, additionalOptions) {
    const getEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const getRequest = assembleRequestGET(ContentType.ArrayBuffer, additionalOptions);
    return arrayBufferFetch(getEndpoint, getRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPromisePUT(endpoint, bodyContentObj, additionalOptions) {
    const putEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const putRequest = assembleRequestWithBody('PUT', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
    return arrayBufferFetch(putEndpoint, putRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPromiseDELETE(endpoint, bodyContentObj, additionalOptions) {
    const deleteEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const deleteRequest = assembleRequestWithBody('DELETE', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
    return arrayBufferFetch(deleteEndpoint, deleteRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPromisePOST(endpoint, bodyContentObj, additionalOptions) {
    const postEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const postRequest = assembleRequestWithBody('POST', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
    return arrayBufferFetch(postEndpoint, postRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function arrayBufferPromisePATCH(endpoint, bodyContentObj, additionalOptions) {
    const patchEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const patchRequest = assembleRequestWithBody('PATCH', bodyContentObj, ContentType.ArrayBuffer, additionalOptions);
    return arrayBufferFetch(patchEndpoint, patchRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPromiseGET(endpoint, additionalOptions) {
    const getEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const getRequest = assembleRequestGET(ContentType.Blob, additionalOptions);
    return blobFetch(getEndpoint, getRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPromisePUT(endpoint, bodyContentObj, additionalOptions) {
    const putEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const putRequest = assembleRequestWithBody('PUT', bodyContentObj, ContentType.Blob, additionalOptions);
    return blobFetch(putEndpoint, putRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPromiseDELETE(endpoint, bodyContentObj, additionalOptions) {
    const deleteEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const deleteRequest = assembleRequestWithBody('DELETE', bodyContentObj, ContentType.Blob, additionalOptions);
    return blobFetch(deleteEndpoint, deleteRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the POST-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPromisePOST(endpoint, bodyContentObj, additionalOptions) {
    const postEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const postRequest = assembleRequestWithBody('POST', bodyContentObj, ContentType.Blob, additionalOptions);
    return blobFetch(postEndpoint, postRequest);
}
/**
 *  endpoint: The endpoint of the REST-Service, e.g. /api/time
 *  bodyContentObj: The body-content of the PATCH-message
 *  additionalOptions({headers: Object, params: Object }): Additional query properties (each as key-value objects, e.g. {params: {"weights": true, "mode": 1}} )
 */
export function blobPromisePATCH(endpoint, bodyContentObj, additionalOptions) {
    const patchEndpoint = assembleEndpoint(endpoint, additionalOptions);
    const patchRequest = assembleRequestWithBody('PATCH', bodyContentObj, ContentType.Blob, additionalOptions);
    return blobFetch(patchEndpoint, patchRequest);
}
function jsonFetch(endpoint, requestObj) {
    const resultMapFunc = (result) => result.json();
    return fetchPromise(endpoint, requestObj, resultMapFunc);
}
function textFetch(endpoint, requestObj) {
    const resultMapFunc = (result) => result.text();
    return fetchPromise(endpoint, requestObj, resultMapFunc);
}
function blobFetch(endpoint, requestObj) {
    const resultMapFunc = (result) => result.blob();
    return fetchPromise(endpoint, requestObj, resultMapFunc);
}
function arrayBufferFetch(endpoint, requestObj) {
    const resultMapFunc = (result) => result.arrayBuffer();
    return fetchPromise(endpoint, requestObj, resultMapFunc);
}
function fetchPromise(endpoint, requestObj, resultMapFunc) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(endpoint, requestObj);
        if (response.ok) {
            return resultMapFunc(response);
        }
        else {
            throw new ConnectionError(response);
        }
    });
}
//# sourceMappingURL=RestServicePromiseUtils.js.map